import styled from "styled-components";

export const StyledColumn = styled.div`
  padding: 1rem;
  flex: 1;
  display: flex;
  gap: 1em;
  flex-direction: column;
`;
